import type { AlignMent } from '@lighthouse/core'
import React, { useCallback } from 'react'
import styled, { css } from 'styled-components'

import { COLORS_MAP } from '../../../../../constants'
import { alignMap, directionMap } from '../../../constant'
import { isValidColor } from '../../../help'
import { type TagGroupOption, TagGroupOptionItem } from './TagGroupOptionItem'

interface TagGroupProps {
    value?: string[]
    options: TagGroupOption[]
    direction?: 'vertical' | 'horizontal'
    align?: AlignMent
    isMultiple?: boolean
    colorless?: boolean
    disabled?: boolean
    onChange: (v: string[]) => void
}

const SCxGroup = styled.div<Pick<React.CSSProperties, 'flexDirection' | 'alignItems'>>`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    ${({ flexDirection, alignItems }) =>
        flexDirection === 'row'
            ? css`
                  flex-direction: row;
                  justify-content: ${alignItems};
              `
            : css`
                  flex-direction: column;
                  align-items: ${alignItems};
              `}
`

export const TagGroup: React.FunctionComponent<TagGroupProps> = ({
    value = [],
    options,
    direction = 'horizontal',
    align = 'left',
    colorless,
    isMultiple,
    disabled,
    onChange
}) => {
    const handleChange = useCallback(
        (v: string[]) => {
            onChange(isMultiple ? v : v.slice(-1))
        },
        [isMultiple, onChange]
    )

    return (
        <SCxGroup flexDirection={directionMap[direction]} alignItems={alignMap[align]}>
            {options.map(option => {
                const checked = value?.includes(option.value)
                const color = option.color
                    ? isValidColor(option.color)
                        ? option.color
                        : `var(${COLORS_MAP[option.color ?? ' ']})`
                    : undefined
                return (
                    <TagGroupOptionItem
                        key={option.value}
                        option={option}
                        checked={checked}
                        color={color}
                        colorless={colorless}
                        disabled={disabled}
                        isMultiple={!!isMultiple}
                        value={value}
                        onChange={handleChange}
                    />
                )
            })}
        </SCxGroup>
    )
}
